module.exports = __webpack_public_path__ + "img/organizations.aa7eec5f.svg";